import { Api } from 'src/apis/api';

export class Eveflow {
  static trackAddToCart = (client: string, transaction_id: string) => {
    Api.sendEveflowAddToCart({
      client,
      transaction_id,
    });
  };
}
